import { AutoMap } from '@automapper/classes';
/* eslint-disable @typescript-eslint/consistent-type-imports */
import type { DocumentId } from '../../types';
import type { UserRoles } from '../types';

export class DocumentAccess {
  @AutoMap(() => String)
  userID: DocumentId;

  @AutoMap(() => [String])
  roles: UserRoles[];
}

export class DocumentMeta {
  @AutoMap(() => [String])
  childrenIds?: DocumentId[];

  @AutoMap(() => [DocumentAccess])
  access?: DocumentAccess[];
}
